module.exports = __webpack_public_path__ + "img/icon-reunion.accb3123.svg";